import React from "react";
import {useNavigate} from "react-router-dom";
import {PrinterIcon} from "@heroicons/react/24/outline";
import {printDetailReport} from "./detailPrint";

/**
 * 상세/등록 상단 액션 버튼.
 * hero: 기본(저장 등) = 흰 솔리드 pill, muted(취소) = 아웃라인 ghost, danger = 빨간 pill
 */
export function DetailSummaryButton({children, muted = false, danger = false, className = "", ...rest}) {
    return (
        <button
            type="button"
            className={`detail-list-summary-action asset-detail-summary-edit${
                danger ? " is-danger" : muted ? " is-muted" : ""
            } ${className}`.trim()}
            {...rest}
        >
            {children}
        </button>
    );
}

/** 상세 hero — 목록 화면으로 이동 */
export function DetailSummaryListButton({url, onClick, children = "목록", className = "", ...rest}) {
    const navigate = useNavigate();

    if (!url && !onClick) {
        return null;
    }

    return (
        <DetailSummaryButton
            muted
            className={className}
            onClick={onClick ?? (() => navigate(url))}
            {...rest}
        >
            {children}
        </DetailSummaryButton>
    );
}

/** 상세 hero — 인쇄 (보고서 탭 등) */
export function DetailSummaryPrintButton({onClick, className = "", ...rest}) {
    return (
        <button
            type="button"
            className={`detail-list-summary-print asset-detail-summary-print print-none ${className}`.trim()}
            onClick={onClick ?? printDetailReport}
            title="인쇄하기"
            aria-label="인쇄하기"
            {...rest}
        >
            <PrinterIcon aria-hidden="true" />
        </button>
    );
}
